import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { Grid } from '@mui/material';
import { Button, FeedbackError, Input } from '../../../../../components';

export const spaceSchema = Yup.object().shape({
  industry: Yup.string().required('Industry is required'),
  size: Yup.string().required('Size is required'),
  space_number: Yup.number()
    .required('# of spaces is required')
    .min(1, 'Please enter a valid number'),
  cost: Yup.number().required('Cost is required').min(1, 'Please enter a valid number'),
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 5,
  p: 4,
};

function ModalEditSpace({ open, handleClose, onSave, space }) {
  const [initialValues, setInitialValues] = useState({
    key: null,
    industry: '',
    size: '',
    spaces: '',
    cost: 0,
  });

  useEffect(() => {
    if (space) setInitialValues(space);
  }, [space]);

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    setInitialValues({ key: null, name: '', price: '' });
    setSubmitting(true);
    handleClose(true);
    resetForm();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Edit
        </Typography>
        <Formik initialValues={initialValues} validationSchema={spaceSchema} onSubmit={onSave}>
          {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <Form
              onSubmit={handleSubmit}
              onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}>
              <Grid container justifyContent="space-around" paddingRight={5} marginTop={3}>
                <Grid item sm={11} marginRight={1} paddingBottom={2}>
                  <label style={{ color: 'gray', marginLeft: 5 }}> Industry </label>
                  <Input
                    name="industry"
                    type="text"
                    placeholder="Industry"
                    value={values.industry}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.industry && touched.industry && 'error'}
                    style={{ marginBottom: 'unset' }}
                  />
                  <FeedbackError name="industry" errors={errors} touched={touched} />
                </Grid>
                <Grid item sm={11} marginRight={1} paddingBottom={2}>
                  <label style={{ color: 'gray', marginLeft: 5 }}> Size </label>
                  <Input
                    name="size"
                    type="text"
                    placeholder="Size"
                    value={values.size}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.size && touched.size && 'error'}
                    style={{ marginBottom: 'unset' }}
                  />
                  <FeedbackError name="size" errors={errors} touched={touched} />
                </Grid>
                <Grid item sm={11} marginRight={1} paddingBottom={2}>
                  <label style={{ color: 'gray', marginLeft: 5 }}> Cost </label>
                  <Input
                    name="cost"
                    type="number"
                    placeholder="Cost"
                    value={values.cost}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.cost && touched.cost && 'error'}
                    style={{ marginBottom: 'unset' }}
                  />
                  <FeedbackError name="cost" errors={errors} touched={touched} />
                </Grid>
                <Grid item sm={11} marginRight={1}>
                  <label style={{ color: 'gray', marginLeft: 5 }}> Number of Spaces </label>
                  <Input
                    name="space_number"
                    type="number"
                    placeholder="# of Spaces"
                    value={values.space_number}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={errors.space_number && touched.space_number && 'error'}
                    style={{ marginBottom: 'unset' }}
                  />
                  <FeedbackError name="space_number" errors={errors} touched={touched} />
                </Grid>
              </Grid>

              <Grid
                container
                justifyContent="center"
                paddingLeft={5}
                paddingRight={5}
                marginTop={3}>
                <Grid item sm={7}>
                  <Button type="submit" label="Edit" />
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

ModalEditSpace.defaultProps = {
  space: undefined,
};

ModalEditSpace.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  space: PropTypes.shape({
    key: PropTypes.string.isRequired,
    industry: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    cost: PropTypes.number.isRequired,
    spaces: PropTypes.number.isRequired,
  }),
};

export default ModalEditSpace;
